// Handles the Android "Share to FoodList" flow from Instagram's share sheet.
// The PWA is registered as a GET share_target (see public/manifest.json), so
// Chrome navigates straight to /share-target?title=&text=&url= with no
// service worker involved. We stash the parsed payload in sessionStorage so
// it survives a bounce through /login, then PlacesPage picks it up on mount.

const STORAGE_KEY = 'foodlist_pending_share';
const MAX_AGE_MS = 10 * 60 * 1000;
const INSTAGRAM_URL_RE = /https?:\/\/(?:www\.)?instagram\.com\/[^\s"'<>]+/i;

export function storePendingShare(search) {
  const params = new URLSearchParams(search);
  const text = params.get('text') || '';
  const urlParam = params.get('url') || '';
  const combined = [urlParam, text].filter(Boolean).join(' ');

  const match = combined.match(INSTAGRAM_URL_RE);
  const instagramUrl = match ? match[0] : (urlParam || text || '');
  if (!instagramUrl) return;

  const remainder = combined.replace(instagramUrl, '').trim();
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
      instagramUrl, remainder, ts: Date.now(),
    }));
  } catch (_) { /* sessionStorage unavailable — just drop it */ }
}

// Reads and clears the pending share, if any (and not stale).
export function takePendingShare() {
  let raw;
  try { raw = sessionStorage.getItem(STORAGE_KEY); } catch (_) { return null; }
  if (!raw) return null;
  try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) {}
  try {
    const pending = JSON.parse(raw);
    if (!pending || Date.now() - pending.ts > MAX_AGE_MS) return null;
    return pending;
  } catch (_) {
    return null;
  }
}

// Ask the foodlist-server to unfurl an Instagram URL via a real headless
// Chromium (Instagram blocks social-crawler UAs now, so this is the only
// reliable path). Returns best-effort caption + guessed place name + a cover
// image URL. Fails soft — the Add Place form still opens with just the IG
// link if this returns null.
export async function fetchInstagramUnfurl(instagramUrl) {
  if (!instagramUrl) return null;
  try {
    const res = await fetch(`/api/unfurl?url=${encodeURIComponent(instagramUrl)}`);
    if (!res.ok) return null;
    const data = await res.json();
    if (!data || !data.ok) return null;
    return {
      caption: (data.caption || '').trim(),
      guessedName: (data.guessedName || '').trim(),
      imageUrl: data.imageUrl || '',
      posterUsername: data.posterUsername || '',
    };
  } catch (_) {
    return null;
  }
}
